import React from 'react';
import TopNav from './TopNav';
import MobileDock from './MobileDock';
import AppFooter from './AppFooter';
import { useAuth } from '../../auth/AuthContext';
import { getEffectiveFieldMode, useFieldMode } from '../../auth/FieldModeContext';
import { isTechnicianShellActive } from './navLinks';
import './app-shell.css';

type AppShellProps = {
    children: React.ReactNode;
    showNav?: boolean;
    showFooter?: boolean;
};

function AppShell({ children, showNav = true, showFooter = true }: AppShellProps): React.JSX.Element {
    const { user } = useAuth();
    const { fieldMode } = useFieldMode();
    const effectiveFieldMode = getEffectiveFieldMode(fieldMode);
    const techShell = isTechnicianShellActive(user?.role, effectiveFieldMode);

    return (
        <div className={`app-shell${techShell ? ' app-shell--technician' : ''}`}>
            {showNav && <TopNav />}
            <main className={`app-shell-main${showNav ? ' app-shell-main--dock' : ''}`}>{children}</main>
            {showNav && <MobileDock />}
            {showFooter && <AppFooter />}
        </div>
    );
}

export default AppShell;
